<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 12 12"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M10.4999 8.24359L8.49988 10.2436L6.49988 8.24359"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M8.50012 10.2436V2.24359"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M1.5 4.24359L3.5 2.24359L5.5 4.24359"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M3.49988 2.24359V10.2436"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconSortArrows',
	props: {
		size: {
			type: [Number, String],
			default: 12
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		strokeWidth: {
			type: [Number, String],
			default: 1
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedStroke() {
			return this.color
		}
	}
}
</script>
